import type { TFunction } from 'i18next';
import { z } from 'zod';

const TRANS_PATH = 'REPORTS.MAILING_FORM.ERRORS';
const LABEL_MAX_LENGTH = 100;

// Field schemas shared by the person and venue mailing forms. A plain shape
// (not a schema) so features can spread it next to their own fields.
const buildReportMailingBaseFormShape = (t: TFunction<'common'>) => ({
  label: z
    .string()
    .trim()
    .min(1, { message: t(`${TRANS_PATH}.LABEL_REQUIRED`) })
    .max(LABEL_MAX_LENGTH, { message: t(`${TRANS_PATH}.LABEL_TOO_LONG`) }),
  isEnabled: z.boolean(),
  sendWeekday: z
    .enum(['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'])
    .nullable(),
  sendHour: z.string(),
  sendMinute: z.string(),
  locale: z.enum(['DE', 'EN']),
  profileNote: z.string(),
  internalNote: z.string(),
});

export type ReportMailingBaseFormShapeType = ReturnType<
  typeof buildReportMailingBaseFormShape
>;

export const getReportMailingBaseFormShape = (
  t: TFunction<'common'>
): ReportMailingBaseFormShapeType => buildReportMailingBaseFormShape(t);
